
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.392 9.706c.305 0 .356-1.777.356-1.777s.508-.254 1.066.406c.66-.203 1.067.355 1.118.355 0 0 .558-.304 1.066.305.66-.152 1.016.305 1.016.305s.507-.254 1.015.355c.559-.101.965.356.965.356v-.864l-2.336-1.726-4.164-2.438L3.33 7.421.994 9.147v.864s.406-.508.965-.356c.508-.61 1.016-.355 1.016-.355s.355-.457 1.015-.305c.457-.61 1.016-.305 1.067-.305 0 0 .406-.609 1.117-.355.558-.61 1.066-.406 1.066-.406s-.152 1.777.152 1.777z"}})])
          )
        }
      }
    